import NewsletterSignup from './newsletter-signup-container';

export default NewsletterSignup;
